import Repository from './repository'

const resource = '/vendedor'

export default {
  getVendedor (data) {
    return Repository.get(`${resource}?cdvendedor=${data}`)
  },
}
